var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 9.375H15.9375V16.875H14.0625V9.375ZM18.75 13.125H20.625V16.875H18.75V13.125ZM9.375 11.25H11.25V16.875H9.375V11.25Z",
    fill: "#18181B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 3.75H15.9375V1.875H14.0625V3.75H6.5625C6.06522 3.75 5.58831 3.94754 5.23667 4.29917C4.88504 4.65081 4.6875 5.12772 4.6875 5.625V18.75C4.6875 19.2473 4.88504 19.7242 5.23667 20.0758C5.58831 20.4275 6.06522 20.625 6.5625 20.625H14.0625V26.25H10.3125V28.125H19.6875V26.25H15.9375V20.625H23.4375C23.9348 20.625 24.4117 20.4275 24.7633 20.0758C25.115 19.7242 25.3125 19.2473 25.3125 18.75V5.625C25.3125 5.12772 25.115 4.65081 24.7633 4.29917C24.4117 3.94754 23.9348 3.75 23.4375 3.75ZM23.4375 18.75H6.5625V5.625H23.4375V18.75Z",
    fill: "#18181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.0e2b48de1a39c68601a384e678da71b5.svg";
export { ForwardRef as ReactComponent };